import * as React from "react";
import * as classes from "./Heading.css";

interface HeadingProps extends React.PropsWithChildren<{}> {}

// Heading renders a title heading.
export default function Heading({ children }: HeadingProps) {
  return <div className={classes.heading}>{children}</div>;
}
